import { Navigate, useSearchParams } from "react-router-dom";
import { AppLayout } from "../../components/layout/Header";
import { clientFromToken, portalPathForClient } from "../../js/api/clientAccess";
import { writeClientPortal } from "../../js/hooks/useClientPortal";

export default function PortalAccess() {
  const [params] = useSearchParams();
  const client = clientFromToken(params.get("token"));
  if (client) {
    writeClientPortal(client);
    return <Navigate to={portalPathForClient(client)} replace />;
  }
  return (
    <AppLayout variant="public">
      <article className="card account-card">
        <h1>Link expired</h1>
        <p>Ask your advisor for a new Client ID or a fresh link.</p>
      </article>
    </AppLayout>
  );
}
